<h2>Detalhes do cliente</h2>
<form #formDetalheCliente="ngForm">
    <div class="row">
        <div class="form-group">
            <span class="icon user"></span>
            <div class="inputs">
                <label for="user-name">Nome</label>
                <input maxlength="60" type="text" class="form-control" id="user-name" name="nomeCliente" [(ngModel)]="fichaCadastro._client.nome" uppercase [charOnly]="true" [readonly]="fichaCadastro._client.nome && !isOutraPessoaCliente" appShowErrorMessages requiredMessage="Nome do Cliente é obrigatório"
                    required maxlength="60" placeholder="Nome do cliente">
                <div *ngIf="!!fichaCadastro._client.nome" class="marginT10 check-mod" (click)="onClickOutraPessoaCliente()">
                    <label for="user-another-name">
                        <input type="checkbox" id="user-another-name" name="clienteOutraPessoaCliente" value="0"  [(ngModel)]="isOutraPessoaCliente"
                        />
                        <span class="radio-label"> “Ops... Essa é outra pessoa.”</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group">
            <span class="icon email"></span>
            <div class="inputs">
                <label for="user-email">Email</label>
                <input maxlength="100" type="text" class="form-control" id="user-email" placeholder="email@exemplo.com.br" required name="email" [(ngModel)]="fichaCadastro._client.email" appEmailValidator appShowErrorMessages requiredMessage="Email do Cliente é obrigatório" />
            </div>
        </div>

        <div class="form-group">
            <span class="icon married"></span>
            <div class="inputs">
                <label for="user-married">Estado Civil</label>
                <select class="form-control" id="user-married" name="estadoCivilCliente" [(ngModel)]="fichaCadastro._client.idEstadoCivil" appShowErrorMessages requiredMessage="Estado Civil do Cliente é obrigatório">
                    <option value="undefined" selected hidden>Selecione...</option>
                    <option value="1">Casado</option>
                    <option value="4">Divorciado</option>
                    <option value="5">Separado</option>
                    <option value="2">Solteiro</option>
                    <option value="3">Viúvo</option>
                    <option value="9">Outro</option>
                </select>
            </div>
        </div>

        <div class="form-group pb0">
            <span class="icon id-number"></span>
            <div class="inputs">
                <label for="user-id">Identificação</label>
                <select class="form-control" id="user-id" name="tipoDocumentoCliente" [(ngModel)]="fichaCadastro._client.idTipoDocumento" appShowErrorMessages requiredMessage="Tipo de Documento do Cliente é obrigatório">
                    <option value="undefined" selected hidden>Selecione o tipo de documento...</option>
                    <option value="2">Carteira de Classe</option>
                    <option value="4">Carteira de Habilitação</option>
                    <option value="3">Carteira Profissional</option>
                    <option value="1">Registro Geral - RG</option>
                </select>
            </div>
        </div>

        <!-- DADOS DOCUMENTOS -->
        <div class="form-group pb0">
            <span class="icon "></span>
            <div class="inputs">
                <label for="user-id">Número</label>
                <input type="text" maxlength="20" class="form-control" appNotCaracter name="numeroDocumentoCliente" [(ngModel)]="fichaCadastro._client.rgIe" placeholder="" appShowErrorMessages requiredMessage="Numero do Documento do Cliente é obrigatório" required
                    uppercase />
            </div>
        </div>

        <div class="form-group pb0">
            <span class="icon "></span>
            <div class="inputs">
                <label for="user-id">Órgão Expedidor</label>
                <input  maxlength="20" type="text" class="form-control" name="orgaoDocumentoCliente" [(ngModel)]="fichaCadastro._client.rgIeEmissor" prgEmlaceholder="" appShowErrorMessages required [charOnly]="true" uppercase />
            </div>
        </div>

        <div class="form-group">
            <span class="icon "></span>
            <div class="inputs">
                <label for="emiss-doc">Data de Emissão</label>
                <input type="text" appDataEmissaoValidator [dataNascimento]="fichaCadastro._client.dataNascimento" class="form-control" id="emiss-doc" name="emissaoDocumentoCliente" [(ngModel)]="fichaCadastro._client.rgIeData" placeholder="Digite apenas números" mask-number [mask]="'99/99/9999'" [reqMin]="1" [dateCheck]="emissaoDocumentoCliente"
                    [dateMin]="minDataEmissao" [dateMax]="maxDataEmissao" #emissaoDocumentoClienteInput="ngModel" appShowErrorMessages required />
                <div class="text-danger" *ngIf="emissaoDocumentoClienteInput?.errors?.dateCheck">Data de emissão do Documento do Cliente inválida</div>
                <div class="text-danger" *ngIf="emissaoDocumentoClienteInput?.errors?.dateRange">Data de emissão do Documento do Cliente deve ser entre {{ minDataEmissao }} e {{ maxDataEmissao }}</div>
            </div>
        </div>

        <div class="form-group">
            <span class="icon mother"></span>
            <div class="inputs">
                <label for="nomeMaeClienteSel">Nome da Mãe</label>
                <select *ngIf="isNomeMaeCliente && !isLoadingNomeMaeCliente" id="nomeMaeClienteSel" class="form-control" name="nomeMaeClienteSel" [(ngModel)]="fichaCadastro._client.nomeMae" #nomeMaeClienteSelect="ngModel" [required]="isNomeMaeCliente" appShowErrorMessages
                    requiredMessage="Nome da Mãe é obrigatório">
                    <option value="" hidden selected>Escolha o nome correto da mãe do cliente</option>
                    <option *ngFor="let nmc of listaNomeMaeCliente" value="{{ nmc.nomeMae }}">{{ nmc.nomeMae }}</option>
                </select>
                <div class="text-danger" *ngIf="!isSelectedNomeMaeClienteAfterBlur">Nome da Mãe do Cliente é obrigatório</div>
                <span *ngIf="isNomeMaeCliente && isLoadingNomeMaeCliente">
                    <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em> Carregando...</span>
                <div *ngIf="!isNomeMaeCliente">
                    <input type="text" maxlength="60" class="form-control" id="user-mon-other-name" placeholder="Digite o nome completo" uppercase [charOnly]="true" maxlength="60" uppercase name="nomeMaeClienteText" [(ngModel)]="fichaCadastro._client.nomeMae" #nomeMaeClienteInput="ngModel"
                        appShowErrorMessages requiredMessage="Nome da Mãe é obrigatório" [required]="!isNomeMaeCliente" />
                </div>
                <div *ngIf="isLoadedListaNomeMaeCliente" class="marginT10 check-mod" (click)="onClickNomeMaeCliente()">
                    <label for="user-mother-name">
                        <input type="checkbox" id="user-mother-name" name="clienteNomeMaeCliente" value="0" [(ngModel)]="isNomeMaeClienteTexto" />
                        <span class="radio-label"> Nome não encontrado na lista</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="form-group">
            <span class="icon father"></span>
            <div class="inputs">
                <label for="user-father-name">Nome do Pai</label>
                <input maxlength="60" [readonly]="isNomePaiClienteTexto" type="text" class="form-control" id="user-father-name" placeholder="Digite o nome completo" uppercase [charOnly]="true" maxlength="60" name="nomePaiCliente" [(ngModel)]="fichaCadastro._client.nomePai" appShowErrorMessages
                    requiredMessage="Nome do Pai do Cliente é obrigatório" [required]="isNomePaiCliente" />
                <div class="marginT10 check-mod" (click)="onClickNomePaiCliente()">
                    <label for="user-father-name">
                        <input maxlength="60" type="checkbox" id="user-father-name" name="ufn" value="0" [(ngModel)]="isNomePaiClienteTexto" />
                        <span class="radio-label"> Sem pai no registro</span>
                    </label>
                </div>

            </div>
        </div>
        <div class="form-group pb0">
            <span class="icon citizenship"></span>
            <div class="inputs">
                <label for="user-citizenship">Nacionalidade</label>
                <select *ngIf="!isLoadingNacionalidadeCliente" id="user-citizenship" class="form-control" name="nacionalidadeCliente" [(ngModel)]="fichaCadastro._client.idNacionalidade" (change)="getIdNacionalidade($event.target.value)" required autocomplete="off" [attr.autocomplete]="false">
                    <option value="undefined" selected hidden>Selecione...</option>
                    <option *ngFor="let nc of listaNacionalidadeCliente" value="{{ nc.id }}">{{ nc.descricao }}</option>
                </select>
                <span *ngIf="isLoadingNacionalidadeCliente">
                    <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em> Carregando...</span>
            </div>
        </div>

        <div class="form-group pb0" *ngIf="fichaCadastro._client.idNacionalidade == 1">
            <span class="icon"></span>
            <div class="inputs">
                <label for="uf-nat-cli">Estado</label>
                <select id="uf-nat-cli" class="form-control" name="naturalUfCliente" (change)="onChangeNaturalUfCliente($event)" [disabled]="fichaCadastro._client.idNacionalidade != 1" [(ngModel)]="fichaCadastro._client.naturalDeUf" required autocomplete="off" [attr.autocomplete]="false"
                    appShowErrorMessages requiredMessage="Estado de Origem do Cliente é obrigatório">
                    <option value="undefined" selected hidden>Selecione...</option>
                    <option value="AC">AC - Acre</option>
                    <option value="AL">AL - Alagoas</option>
                    <option value="AP">AP - Amapá</option>
                    <option value="AM">AM - Amazonas</option>
                    <option value="BA">BA - Bahia</option>
                    <option value="CE">CE - Ceará</option>
                    <option value="DF">DF - Distrito Federal</option>
                    <option value="ES">ES - Espírito Santo</option>
                    <option value="GO">GO - Goiás</option>
                    <option value="MA">MA - Maranhão</option>
                    <option value="MT">MT - Mato Grosso</option>
                    <option value="MS">MS - Mato Grosso do Sul</option>
                    <option value="MG">MG - Minas Gerais</option>
                    <option value="PA">PA - Pará</option>
                    <option value="PB">PB - Paraíba</option>
                    <option value="PR">PR - Paraná</option>
                    <option value="PE">PE - Pernambuco</option>
                    <option value="PI">PI - Piauí</option>
                    <option value="RJ">RJ - Rio de Janeiro</option>
                    <option value="RN">RN - Rio Grande do Norte</option>
                    <option value="RS">RS - Rio Grande do Sul</option>
                    <option value="RO">RO - Rondônia</option>
                    <option value="RR">RR - Roraima</option>
                    <option value="SC">SC - Santa Catarina</option>
                    <option value="SP">SP - São Paulo</option>
                    <option value="SE">SE - Sergipe</option>
                    <option value="TO">TO - Tocantins</option>
                </select>

            </div>
        </div>

        <div class="form-group" *ngIf="fichaCadastro._client.idNacionalidade == 1">
            <span class="icon"></span>
            <div class="inputs">
                <label for="user-city-cli">Cidade</label>
                <select *ngIf="!isLoadingNaturalCidadeCliente" autocomplete="off" [attr.autocomplete]="false" id="user-city-cli" class="form-control" [disabled]="fichaCadastro._client.idNacionalidade != 1 || !fichaCadastro._client.naturalDeUf" name="naturalCidadeCliente"
                    [(ngModel)]="fichaCadastro._client.naturalDe" required appShowErrorMessages requiredMessage="Cidade de Origem do Cliente é obrigatório">
                    <option value="undefined" selected hidden>Selecione...</option>
                    <option *ngFor="let ncid of listaNaturalCidadeCliente" value="{{ ncid.nomeCidade }}">{{ ncid.nomeCidade }}</option>
                </select>

                <span *ngIf="isLoadingNaturalCidadeCliente">
                    <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em> Carregando...</span>
            </div>
        </div>

        <app-dados-profissionais #dadosProfissionaisComponent name="dadosProfissionais" [(ngModel)]="fichaCadastro._client.dadoProfissional" ngDefaultControl>
        </app-dados-profissionais>



        <div class="form-group">
            <span class="icon patrimony"></span>
            <div class="inputs">
                <label for="user-patrimony">Valor total do Patrimônio</label>
                <input type="text"
                      class="form-control"
                      id="user-patrimony"
                      placeholder="Digite apenas números"
                      mask-money
                      appOnlyMoney
                      [prefix]="'R$'"
                      maxlength="17"
                      appShowErrorMessages
                      required
                      requiredMessage="Valor do patrimônio é obrigatório"
                      name="valorPatrimonioCliente"
                      [(ngModel)]="fichaCadastro._client.valorPatrimonio"
                />
                <small>EX: veículo, imóvel, investimentos...
                    <br>
                    <strong>Importante</strong>: essa é uma informação exigida pelo Banco Central.</small>

            </div>
        </div>

        <div class="form-group">
            <span class="icon public-person"></span>
            <div class="inputs">
                <label for="user-expose">Politicamente Exposto?</label>
                <small class="subtitle">Exerceu cargo político nos últimos 5 anos ou é parente de algum?</small>
                <div class="input-box" data-toggle="buttons">
                    <label class="btn btn-default btn-circle btn-lg" (click)="setClientePpe('S')">
                        <input type="radio" name="q1" value="N"   >
                    </label>
                    <span class="radio-label">sim</span>
                    <label class="btn btn-default btn-circle btn-lg active" (click)="setClientePpe('N')">
                        <input type="radio" name="q1" value="S" >
                    </label>
                    <span class="radio-label">não</span>
                </div>
            </div>
        </div>

        <div class="form-group">
          <span class="icon public-person"></span>
          <div class="inputs">
              <label for="user-expose">FATCA</label>
              <small class="subtitle">Você possui obrigação fiscal com os Estados Unidos da América ou seus territórios?</small>
              <div class="input-box" data-toggle="buttons">
                  <label class="btn btn-default btn-circle btn-lg" (click)="setFatca('S')">
                      <input type="radio" name="q1" value="N"   >
                  </label>
                  <span class="radio-label">sim</span>
                  <label class="btn btn-default btn-circle btn-lg active" (click)="setFatca('N')">
                      <input type="radio" name="q1" value="S" >
                  </label>
                  <span class="radio-label">não</span>
              </div>
          </div>
      </div>

        <div class="form-group">
            <span class="icon mobile"></span>
            <div class="inputs">
                <label for="user-phone">Telefones Adicionais</label>
                <div class="phone-list">
                    <!-- PHONE LIST -->
                    <div class="input-group phone-input">
                        <span class="input-group-addon" style="width:110px;text-align:right">Celular:</span>
                        <input type="text" name="foneCelularCliente" class="form-control" placeholder="(00) 00000-0000" [(ngModel)]="fichaCadastro._client.telefones.celularAdicional" appTelefone />
                    </div>
                    <div class="input-group phone-input">
                        <span class="input-group-addon" style="width:110px;text-align:right">Residencial:</span>
                        <input type="text" name="foneResidencialCliente" class="form-control" placeholder="(00) 0000-0000" minlength="10" maxlength="14" [(ngModel)]="fichaCadastro._client.telefones.residencial" appShowErrorMessages appTelefone />
                    </div>
                    <div class="input-group phone-input">
                        <span class="input-group-addon" style="width:110px;text-align:right">Comercial:</span>
                        <input type="text" name="foneComercialCliente" class="form-control" placeholder="(00) 0000-0000" minlength="10" maxlength="14" [(ngModel)]="fichaCadastro._client.telefones.comercial" appShowErrorMessages appTelefone/>
                    </div>
                    <!-- PHONE LIST -->
                </div>
                <small>
                    <strong>Importante:</strong> precisamos de um número de contato direto com o cliente para agilizar o processo.</small>
            </div>
        </div>

        <div class="form-group">
            <span class="icon reference"></span>
            <div class="inputs">
                <label for="user-reference">Referência</label>
                <input maxlength="40" type="text" class="form-control" id="user-reference" placeholder="Digite o nome de uma referência do cliente" uppercase [charOnly]="true"  minlength="3" name="nomeReferenciaCliente" [(ngModel)]="fichaCadastro._client.clienteReferencia.nome"
                    required appShowErrorMessages requiredMessage="Nome da Referencia é obrigatório" />

            </div>
        </div>

        <div class="form-group">
            <span class="icon reference"></span>
            <div class="inputs">
                <label for="user-reference-phone">Contato da Referência</label>
                <input type="text" class="form-control" id="user-reference-phone" appTelefone placeholder="(00) 00000-0000" minlength="10" name="foneReferenciaCliente" [(ngModel)]="fichaCadastro._client.clienteReferencia.telefone" required appShowErrorMessages requiredMessage="Contato da Referencia é obrigatório"
                />

            </div>
        </div>

        <div class="form-group">
            <span class="icon reference"></span>
            <div class="inputs">
                <label for="user-reference-relation">Relação com a Referência</label>
                <select id="user-reference-relation" class="form-control" name="relacReferenciaCliente" required appShowErrorMessages requiredMessage="Nome da Referencia é obrigatório" (change)="onChangeRelacReferenciaCliente($event)" [(ngModel)]="fichaCadastro._client.clienteReferencia.idGrauRelacionamento"
                    #relacReferenciaClienteSelect="ngModel">
                    <option value="undefined" hidden selected>Selecione</option>
                    <option value="1">Amigo</option>
                    <option value="2">Parente</option>
                    <option value="3">Vizinho</option>
                    <option value="4">Outros</option>
                </select>

            </div>
        </div>

    </div>
</form>

<div class="row">
    <div class="marginT30 form-group tab-buttons">
        <a (click)="onClickPrevious()" class="bt-back btn btn-border-orange pull-left" *ngIf="!fichaCadastro.getFichaLocalStorage">
            <em class="fa fa-arrow-left mrBt"></em> Voltar</a>
        <a class="bt-go btn btn-full-orange pull-right" [ngClass]="{'disabled': !formDetalheCliente.valid}" (click)="onClickNext()">Continuar
            <em class="fa fa-arrow-right mlBt"></em>
        </a>
    </div>
</div>
